module.exports = __webpack_public_path__ + "static/media/Enscape_2022-10-26-11-46-00.b2a16443.jpg";